<template>
    <div>
        <CCard>
            <CCardBody>
                <v-toolbar flat color="white">
                    <v-toolbar-title>فاکتور فروش</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="confirmDialog" max-width="400px">
                        <v-card>
                            <v-card-text class="pb-0">
                                <v-container class="pb-0">
                                    <p class="mt-2">آیا از این کار اطمینان دارید؟</p>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <CButton color="danger" class="mb-2 ml-2 text-white"
                                         @click="confirmDialog = false">
                                    خیر
                                </CButton>
                                <CButton color="primary" class="mb-2 ml-2 text-white"
                                         @click="confirm_cancel()">
                                    بلی
                                </CButton>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="alertDialog.visible" max-width="400px">
                        <v-card>
                            <v-card-text class="pb-0">
                                <v-container class="pb-0">
                                    <p class="mt-3" style="text-align: center;">{{ alertDialog.content }}</p>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <CButton color="primary" class="mb-2 text-white" style="margin:auto;" @click="alertDialogHide()">
                                    باشه
                                </CButton>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>


                </v-toolbar>
                <CRow>
                    <CCol sm="3">
                        <CInput
                                label="شناسه فاکتور فروش"
                                v-model="InvoiceIdText"
                                @keypress="isNumber($event)"
                                v-hotkey="keymap"
                                :disabled="DisableInvoiceIdText"
                                dir="ltr"
                        />
                    </CCol>
                    <CCol sm="3">
                        <CButton color="primary" class="text-white mt-7" @click="invoiceSearch">
                            جستجو
                        </CButton>
                        <CButton color="info" class="text-white mt-7 mr-7" @click="resetForm" v-show="DisableInvoiceIdText">
                            ورود فاکتور جدید
                        </CButton>                        
                    </CCol>
                  
                </CRow>
                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> اطلاعات فاکتور </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="6">
                                            <label>شناسه فاکتور: <b>{{invoiceInfo.invoice_id}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>جمع کل: <b>{{ invoiceInfo.amount | currency('', 0, { symbolOnLeft: false })}} ریال</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>تخفیف این فاکتور: <b>{{ invoiceInfo.discount | currency('', 0, { symbolOnLeft: false })}} ریال</b></label>
                                        </CCol>                                        
                                        <CCol sm="6">
                                            <label v-show="invoiceInfo.transaction_id">شناسه تراکنش اسنپ پی <b>{{ invoiceInfo.transaction_id }}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label> مبلغ برای اسنپ پی: <b>{{ invoiceInfo.transaction_amount | currency('', 0, { symbolOnLeft: false })}} ریال</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>تخفیف برای اسنپ پی : <b>{{ invoiceInfo.transaction_discount | currency('', 0, { symbolOnLeft: false })}} ریال</b></label>
                                        </CCol>                                           
                                     
                                        <CCol sm="12">

                                            <CButton color="warning" class="text-white mb-2 ml-2" @click="get_status()">
                                                چک کردن وضعیت
                                            </CButton>

                                            <CButton color="danger" class="text-white mb-2 ml-2" v-show="status == 2" @click="cancel()" >
                                                کنسل کردن سفارش
                                            </CButton>

 

                                        </CCol>

                                    </CRow>
                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>




  

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo && status < 1" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>ثبت بارکد</strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="2">
                                            <CInput
                                                    label="بارکد"
                                                    v-model="BarcodeText"
                                                    dir="ltr"
                                            />
                                        </CCol>
                                        <CCol sm="2">
                                            <div class="form-group">
                                                <label>مبلغ به ریال</label>
                                                <money v-model="AmountText"  v-bind="money" dir="ltr" class="form-control"/>
                                            </div>                                            
                                        </CCol>
                                        <CCol sm="2">
                                            <div class="form-group">
                                                <label>تخفیف به ریال</label>
                                                <money v-model="DiscountText"  v-bind="money" dir="ltr" class="form-control"/>
                                            </div>                                            
                                        </CCol>                                        
                                        <CCol sm="3">
                                            <CButton color="info" class="text-white mt-7" @click="withdraw()">
                                                ثبت
                                            </CButton>  
                                        </CCol>
                                    </CRow>

                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>  
                


                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo && status == 1" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>تایید نهایی</strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="3">
                                            <CInput
                                                    label="کد ارجاع"
                                                    v-model="ReferenceCodeText"
                                                    dir="ltr"
                                            />
                                        </CCol>
                                        <CCol sm="3">
                                            <CButton color="success" class="text-white mt-7" @click="finalize()">
                                                ثبت نهایی
                                            </CButton>  
                                            <CButton color="danger" class="text-white mt-7 mr-7" @click="create_new_transaction_id()">
                                                ثبت بارکد جدید
                                            </CButton>                                              
                                        </CCol>
                                    </CRow>

                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>  

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>تاریخچه</strong>
                                </CCardHeader>
                                <CCardBody>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>


                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>                   





            </CCardBody>
        </CCard>


    </div>
</template>

<script>
    import {      
        callWebservice,
        getFunction         
    } from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons';
    import moment from "moment-jalaali";

    export default {
        name: 'Snappay',
        props: {},
        iconsSet,

        methods: {
            getObjectNameById(list, key, id, extraKey) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i][key] === id) {
                        if (extraKey) {
                            return list[i].name + ' ' + list[i][extraKey]
                        }
                        return list[i].name
                    }
                }
            },
            convertDateToJDate(dt) {
                if (dt === null) {
                    return 'نامشخص'
                }
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
            convertDateToJDateWD(dt) {
                if (dt === null) {
                    return 'نامشخص'
                }
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },            
            resetForm(){
                this.InvoiceIdText = "";
                this.collapseInvoiceInfo = false;
                this.status = 0;
                this.DisableInvoiceIdText = false;                
            },
            invoiceSearch() {                
                this.collapseInvoiceInfo = false;
                let data = {
                    "invoice_id": this.InvoiceIdText
                }

                callWebservice(this.$http, 'snappay/info',data).then((resp) => {
                    this.invoiceInfo = resp;
                    this.collapseInvoiceInfo = true;
                    this.confirmDialog = false;
                    this.status = resp.transaction_status;
                    this.DisableInvoiceIdText = true;
                    this.AmountText = resp.transaction_amount;
                    this.DiscountText = resp.transaction_discount;

                    getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                        "code": "snappay",
                        "code_id": this.InvoiceIdText
                    }).then((resp) => {
                        this.selectedItemLogs = resp.list
                    })                      


                }, (err) => {
                    this.errors = err.body.errors;
                    this.$toasted.show(err.body.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                });



              
            },
            withdraw() {                
                let data = {
                    "invoice_id": this.InvoiceIdText,
                    "barcode_token": this.BarcodeText,
                    "amount": this.AmountText,
                    "discount": this.DiscountText,
                }

                callWebservice(this.$http, 'snappay/withdraw',data).then((resp) => {
                    this.alert(resp.message);
                }, (err) => {
                    this.alert(err.body.message);
                });

                
              
            },        
            finalize() {
                let data = {
                    "invoice_id": this.InvoiceIdText,
                    "reference_code": this.ReferenceCodeText
                }

                callWebservice(this.$http, 'snappay/finalize',data).then((resp) => {
                    this.alert(resp.message);
                }, (err) => {
                    this.alert(err.body.message);
                });
                
            },  
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            goToBlankRoute(routeName) {
                let routeData = '/#'  + routeName;
                window.open(routeData, '_blank');
            },
            alert(msg){
                this.alertDialog.content = msg;
                this.alertDialog.visible = true;
            },     
            get_status(){
                let data = {
                    "invoice_id": this.InvoiceIdText,
                }

                callWebservice(this.$http, 'snappay/status',data).then((resp) => {
                    this.alert(resp.message);
                }, (err) => {
                    this.alert(err.body.message);
                });
            },
            cancel(){
                this.confirmDialog = true;
            },
            confirm_cancel(){
                this.confirmDialog = false;

                let data = {
                    "invoice_id": this.InvoiceIdText,
                }

                callWebservice(this.$http, 'snappay/cancel',data).then((resp) => {
                    this.alert(resp.message);
                }, (err) => {
                    this.alert(err.body.message);
                });
                
            },

            create_new_transaction_id(){
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {
                    let data = {
                        "invoice_id": this.InvoiceIdText,
                    }

                    callWebservice(this.$http, 'snappay/new_transaction',data).then((resp) => {
                        this.alert(resp.message);
                    }, (err) => {
                        this.alert(err.body.message);
                    });                    
                }
            },

            alertDialogHide(){                
                this.alertDialog.visible = false;
                this.invoiceSearch(); 
            },



                    
        },
        data: () => {
            return {
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],  
                selectedItemLogs: [],                                      
                InvoiceIdText: '',
                BarcodeText: '',
                ReferenceCodeText: '',
                status: 0,
                DisableInvoiceIdText: false,

                invoiceInfo: {},
                collapseInvoiceInfo: false,
                confirmDialog: false,
                alertDialog:{visible: false,content: ''},
                AmountText: 0,
                DiscountText: 0,
                money: {
                    decimal: '',
                    thousands: ',',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.InvoiceIdText = this.$route.params.id;
                this.invoiceSearch();
            }

        },
        computed: {
            keymap() {
                return {
                    'enter': {
                        keyup: this.invoiceSearch
                    }
                }
            }
        },
        watch: {


        }

    }
</script>
